module.exports = __webpack_public_path__ + "static/media/Panton-SemiBold.847f435b.ttf";